<script>
export default {
  name: 'LadSearchCommon',
  props: {
    item: { type: Object, required: true },
  },
  data() {
    return {
      base: 'search',
    }
  },
}
</script>
